import React from "react";

const Footer = () => {
  return (
    <div id="about" className=" bg-indigo-500 px-10 py-10 xs:px-5">
      <p className=" max-w-[1000px] font-bold font-barlow text-xl text-white text-pretty">
        Developed by Computer Science undergraduates from Pune Institute of
        Computer Technology, Efir aims to revolutionize FIR processing,
        promoting fairness and accessibility. Our mission is to empower
        individuals and strengthen community trust in the legal system.
      </p>
    </div>
  );
};

export default Footer;
